import * as angular from 'angular';
import { IUtilities } from '../../typings/services';
import { ClInputContainerController } from './ClInputContainerDirective';

/**
 * Simple wrapper for label, to help defer compilation of a cl-input-container until all elements are ready to be compiled.
 */

export class ClLabelDirective implements angular.IDirective {
    public static $name: string = 'clLabel';
    public restrict: string = 'E';

    public require: string = '^clInputContainer';

    public link = (scope: any, element: angular.IAugmentedJQuery,
                   attrs: angular.IAttributes, clInputContainerCtrl: ClInputContainerController) => {
        /* Create a new label, copy attributes over & assign text */
        let label = angular.element('<label />');
        this.utilities.copyAllAttributes(label, attrs);
        label.text(element.text());

        /* Attach validated input to controller so we can use it to $compile */
        clInputContainerCtrl.label = label;

        /**
         * Remove the original element so that we can use the contents
         * of the input container that were not covered by a directive like this one
         */
        element.remove();

        /* Don't $compile here -- the $compile takes place in the ClInputContainerDirective */
    }

    constructor(
        private utilities: IUtilities
    ) {
    }

    public static Factory() {
        let directive = (utilities) => {
            return new ClLabelDirective(utilities);
        };

        directive['$inject'] = ['utilities'];

        return directive;
    }
}
